import { render, staticRenderFns } from "./DisputeContactDetailsModal.vue?vue&type=template&id=0fae8768"
import script from "./DisputeContactDetailsModal.vue?vue&type=script&lang=js"
export * from "./DisputeContactDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./DisputeContactDetailsModal.vue?vue&type=style&index=0&id=0fae8768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports